import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  
  return getRequest(`workOrderCostTypeTotal/get-list/${size || 10}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`workOrderCostTypeTotal/edit/${id}`)
}

export async function save(values) {
  return postRequest(`workOrderCostTypeTotal/save`, values)
}

export function remove(values) {
  return postRequest(`workOrderCostTypeTotal/delete`, values)
}
